import { render, staticRenderFns } from "./DashboSp.vue?vue&type=template&id=61e333ad"
import script from "./DashboSp.js?vue&type=script&lang=js&external"
export * from "./DashboSp.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports